import { render, staticRenderFns } from "./recipients-tracker.vue?vue&type=template&id=d357c5ec&scoped=true&"
import script from "./recipients-tracker.vue?vue&type=script&lang=js&"
export * from "./recipients-tracker.vue?vue&type=script&lang=js&"
import style0 from "./recipients-tracker.vue?vue&type=style&index=0&id=d357c5ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d357c5ec",
  null
  
)

export default component.exports